// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-m_fn","advertDetailHeaderPrice__value":"c-m_fo","advertDetailHeaderPrice__label":"c-m_fp"};